import Phaser from 'phaser';
import { ControlPanel } from './components/ControlPanel';
import { TopBar } from './components/TopBar';

export class WelcomeScene extends Phaser.Scene {
  private screenWidth = 750;
  private screenHeight = 1334;
  private timer;
  private index;
  private countdownLogo;
  private nextDraw;
  private backgroundAnimation;

  constructor() {
    super('WelcomeScene');
  }

  create() {
    this.index = 5;
    const background = this.add.sprite(this.screenWidth / 2, this.screenHeight / 2, 'background');
    background.setDisplaySize(this.screenWidth, this.screenHeight);
    this.addCountdown();
    new TopBar(this, this.screenWidth);
    new ControlPanel(this, this.screenWidth, this.screenHeight);
  }

  // addBackground() {
  //   this.backgroundAnimation = new BackgroundAnimation(this, this.screenWidth, this.screenHeight);
  //   this.backgroundAnimation?.start();
  // }

  addCountdown() {
    this.nextDraw = this.add.image(this.screenWidth / 2, this.screenHeight * 0.3, 'next_draw');
    this.countdownLogo = this.add.sprite(this.screenWidth / 2, this.screenHeight * 0.625, 'countdown_' + this.index);
    this.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.8, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.timer = this.time.addEvent({
      delay: 900,
      callback: this.updateCountdown,
      callbackScope: this,
      loop: true
    });
  }

  updateCountdown() {
    // texture not loaded yet...
    if (!this.countdownLogo?.texture) return;

    this.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.8, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.index -= 1;

    if (this.index < 0) {
      this.time.removeEvent(this.timer);
      this.scene.start('SpinScene');
      return;
    } else if (this.index === 0) {
      this.countdownLogo.setY(this.screenHeight * 0.5);
      this.nextDraw.setVisible(false);
    }

    this.countdownLogo.setTexture('countdown_' + this.index);
  }

  pauseTimer() {
    this.time.paused = true;
    this.backgroundAnimation?.pause();
  }

  resumeTimer() {
    this.time.paused = false;
    this.backgroundAnimation?.resume();
  }
}
